export const goProposeToTheEndOgArray = ({ id, array, setNewArray }) => {
    const IndexOfPropose = array === null || array === void 0 ? void 0 : array.findIndex(({ _id }) => _id === id);
    if (IndexOfPropose < 0)
        return;
    const newList = [...array];
    const deletedP = newList.splice(IndexOfPropose, 1);
    newList.push(...deletedP);
    setNewArray(newList);
};
